import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";

const appearance = {
  theme: dark,
  captcha: { theme: "dark" },
  variables: {
    colorPrimary: "#CCFF00",
    colorPrimaryForeground: "#000000",
    colorBackground: "#131313",
    colorInput: "#0A0A0A",
    fontFamily: "Manrope, sans-serif",
    borderRadius: "0.25rem",
  },
};

const localization = {
  locale: "pt-PT",
  formFieldLabel__emailAddress: "Email",
  formFieldLabel__password: "Palavra-passe",
  formFieldInputPlaceholder__emailAddress: "Introduza o seu email",
  formFieldInputPlaceholder__password: "Introduza a palavra-passe",
  formFieldInputPlaceholder__signUpPassword: "Crie uma palavra-passe",
  formFieldInputPlaceholder__signInPassword: "Introduza a palavra-passe",
  formFieldAction__forgotPassword: "Esqueceu a palavra-passe?",
  formButtonPrimary: "Continuar",
  signIn: {
    start: {
      title: "Entrar no {{applicationName}}", subtitle: "Inicie sessão para ver os seus relatórios", actionText: "Não tem conta?", actionLink: "Registar",
      titleCombined: "Entrar no {{applicationName}}", subtitleCombined: "Inicie sessão ou registe-se com o seu email",
    },
    password: { title: "Introduza a palavra-passe", subtitle: "para continuar para {{applicationName}}", actionLink: "Usar outro método" },
  },
  signUp: {
    start: { title: "Criar conta", subtitle: "Registe-se com o seu email", actionText: "Já tem conta?", actionLink: "Entrar" },
    emailCode: {
      title: "Confirme o seu email", subtitle: "para continuar para {{applicationName}}",
      formTitle: "Código de confirmação", formSubtitle: "Introduza o código enviado para o seu email", resendButton: "Não recebeu o código? Reenviar",
    },
  },
  userButton: { action__signOut: "Terminar sessão", action__manageAccount: "Gerir conta" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>O início de sessão está indisponível. Atualize a página para tentar novamente.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={localization}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/sign-in"
    >
      {children}
    </ClerkProvider>
  );
}
